import { render } from "./Adjustment.vue?vue&type=template&id=1b58f1b8&scoped=true"
import script from "./Adjustment.vue?vue&type=script&lang=ts"
export * from "./Adjustment.vue?vue&type=script&lang=ts"

import "./Adjustment.vue?vue&type=style&index=0&id=1b58f1b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b58f1b8"

export default script